var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Model from 'models/Model';
import OrderEntity from './OrderEntity';
var ServiceOrderItem = /** @class */ (function (_super) {
    __extends(ServiceOrderItem, _super);
    function ServiceOrderItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceOrderItem.prototype.getId = function () {
        return Number(this.id);
    };
    ServiceOrderItem.prototype.getOrderEntityId = function () {
        return Number(this.order_entity_id);
    };
    ServiceOrderItem.prototype.setOrderEntityId = function (orderEntityId) {
        this.order_entity_id = orderEntityId;
    };
    ServiceOrderItem.prototype.getPackagePriceId = function () {
        return this.package_price_id != null ? Number(this.package_price_id) : undefined;
    };
    ServiceOrderItem.prototype.setPackagePriceId = function (packagePriceId) {
        this.package_price_id = packagePriceId;
    };
    ServiceOrderItem.prototype.getUnitPrice = function () {
        return Number(this.unit_price || 0);
    };
    ServiceOrderItem.prototype.getStatus = function () {
        return this.status;
    };
    ServiceOrderItem.prototype.setStatus = function (status) {
        this.status = status;
    };
    ServiceOrderItem.prototype.getNotes = function () {
        return this.notes || '';
    };
    ServiceOrderItem.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    ServiceOrderItem.prototype.getOrderEntity = function () {
        return this.order_entity ? plainToClass(OrderEntity, this.order_entity) : undefined;
    };
    ServiceOrderItem.prototype.needsResult = function () {
        var _a;
        var entityType = (_a = this.getOrderEntity()) === null || _a === void 0 ? void 0 : _a.getEntityType();
        return entityType === 'lab' || entityType === 'ray';
    };
    ServiceOrderItem.prototype.getResultText = function () {
        return (this.service_order_item_results || [])
            .map(function (row) { var _a; return (_a = row.resultable) === null || _a === void 0 ? void 0 : _a.result; })
            .filter(function (value) { return Boolean(value); })
            .join('\n');
    };
    ServiceOrderItem.prototype.getLineTotal = function () {
        return this.getUnitPrice();
    };
    return ServiceOrderItem;
}(Model));
export default ServiceOrderItem;
